let boundHandler = null;

export function toggle() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const chatWindow = container.querySelector('#chatkit-window');
  const toggleButton = container.querySelector('#chatkit-toggle');
  if (!chatWindow || !toggleButton) return;

  const isOpen = chatWindow.style.display === 'flex';

  if (!isOpen) {
    chatWindow.style.display = 'flex';
    toggleButton.style.display = 'none';
    document.dispatchEvent(new CustomEvent('chatkit.toggle.open'));
  } else {
    chatWindow.style.display = 'none';
    toggleButton.style.display = 'block';
    document.dispatchEvent(new CustomEvent('chatkit.toggle.close'));
  }
}

export function setup() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const toggleButton = container.querySelector('#chatkit-toggle');
  const closeButton = container.querySelector('#chatkit-close');

  boundHandler = () => toggle();

  if (toggleButton) toggleButton.addEventListener('click', boundHandler);
  if (closeButton) closeButton.addEventListener('click', boundHandler);
}

export function cleanup() {
  const container = document.getElementById('chatkit-widget-container');

  if (container && boundHandler) {
    const toggleButton = container.querySelector('#chatkit-toggle');
    const closeButton = container.querySelector('#chatkit-close');
    if (toggleButton) toggleButton.removeEventListener('click', boundHandler);
    if (closeButton) closeButton.removeEventListener('click', boundHandler);
  }

  boundHandler = null;
}
